/**
 * SuperTrandafiri v12.2 - Shopify Customer Events publisher.
 * No Meta Pixel is loaded directly from the theme.
 * Tracking permissions are enforced by Shopify's Custom Pixel manager.
 * No browser cookies, customer personal data, or CAPI credentials are read here.
 */
(() => {
  'use strict';
  let initiatedCheckout = false;
  const purchases = new Set();

  function publish(name, payload) {
    try {
      const analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') return false;
      analytics.publish(name, payload);
      return true;
    } catch (_) {
      return false;
    }
  }

  function itemsFrom(cart) {
    return (cart?.items || []).map(item => ({
      id: String(item.variant_id || ''),
      quantity: Number(item.quantity || 0)
    })).filter(item => item.id && item.quantity > 0);
  }

  function trackAdd(variantId, quantity, priceCents, currency = 'RON') {
    const qty = Number(quantity || 1);
    return publish('st:add_to_cart', {
      content_type: 'product', content_ids: [String(variantId)],
      contents: [{id: String(variantId), quantity: qty}],
      num_items: qty,
      value: Math.round(Number(priceCents || 0) * qty) / 100,
      currency: String(currency || 'RON')
    });
  }

  function trackCheckout(cart, currency = 'RON') {
    if (initiatedCheckout || !cart?.items?.length) return false;
    const contents = itemsFrom(cart);
    const published = publish('st:checkout_start', {
      value: Number(cart.total_price || 0) / 100,
      currency: String(currency || 'RON'),
      content_type: 'product', contents,
      content_ids: contents.map(item => item.id),
      num_items: Number(cart.item_count || 0)
    });
    if (published) initiatedCheckout = true;
    return published;
  }

  function trackPurchase(cart, result, requestId, currency = 'RON') {
    if (!result?.ok || !result?.orderName || !requestId) return false;
    const eventId = 'st-purchase-' + String(requestId);
    if (purchases.has(eventId)) return false;
    try {
      if (sessionStorage.getItem('st-meta-last-purchase') === eventId) return false;
    } catch (_) {}

    const orderValue = Number(result.orderValue);
    const value = Number.isFinite(orderValue) && orderValue >= 0
      ? orderValue : Number(cart?.total_price || 0) / 100;
    const contents = itemsFrom(cart);
    const published = publish('st:purchase', {
      eventId,
      value: Math.round(value * 100) / 100,
      currency: String(result.currency || currency || 'RON'),
      content_type: 'product', content_ids: contents.map(item => item.id),
      contents, num_items: Number(cart?.item_count || 0),
      order_id: String(result.orderName)
    });
    if (published) {
      purchases.add(eventId);
      try { sessionStorage.setItem('st-meta-last-purchase', eventId); } catch (_) {}
    }
    return published;
  }

  // Keep the theme/backend integration stable while CAPI is configured separately.
  // No marketing attribution data is sent to the order endpoint from this theme.
  window.STMeta = {
    getOrderMeta: () => ({ consent: false }),
    trackAdd, trackCheckout, trackPurchase
  };
})();
